
/* APEX PRO SERIES — Premium Cart Drawer | Inventory Protection */
(function () {
  'use strict';

  var root = document.querySelector('[data-apex-cart-drawer]');
  if (!root) return;

  var panel = root.querySelector('[data-apex-drawer-panel]');
  var itemsNode = root.querySelector('[data-apex-drawer-items]');
  var emptyNode = root.querySelector('[data-apex-drawer-empty]');
  var footer = root.querySelector('[data-apex-drawer-footer]');
  var countNode = root.querySelector('[data-apex-drawer-count]');
  var subtotalNode = root.querySelector('[data-apex-drawer-subtotal]');
  var statusNode = root.querySelector('[data-apex-drawer-status]');
  var messageNode = root.querySelector('[data-apex-drawer-message]');

  var lastFocus = null;
  var lastOverflow = '';
  var busy = false;
  var closeTimer = null;
  var inventoryWarning = null;
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var focusSelector = 'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function money(cents) {
    try {
      return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function request(url, options) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, options || {}))
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status >= 400) {
            var error = new Error(data.description || data.message || 'Cart could not be updated.');
            error.status = response.status;
            throw error;
          }
          return data;
        });
      });
  }

  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  }

  function showInventoryWarning(key, quantity) {
    var rows = itemsNode.querySelectorAll('.apex-cart-drawer__item');
    var target = null;
    Array.prototype.forEach.call(rows, function (row) {
      var button = row.querySelector('[data-apex-qty-change="1"]');
      if (button && button.dataset.key === key) target = row;
    });
    if (!target) return;

    var details = target.querySelector('.apex-cart-drawer__item-details');
    if (!details) return;
    inventoryWarning = element('div', 'apex-cart-drawer__inventory-warning');
    inventoryWarning.setAttribute('role', 'alert');
    inventoryWarning.textContent = 'Only ' + quantity +
      ' available for this item. Your cart quantity remains at ' + quantity + '.';
    details.appendChild(inventoryWarning);
    messageNode.textContent = inventoryWarning.textContent;
  }

  function clearInventoryWarning() {
    if (inventoryWarning) inventoryWarning.remove();
    inventoryWarning = null;
  }

  function render(cart) {
    currency = cart.currency || currency;
    clearInventoryWarning();
    itemsNode.replaceChildren();

    var isEmpty = cart.item_count === 0;
    countNode.textContent = isEmpty ? '' : '(' + cart.item_count + ')';
    statusNode.hidden = isEmpty;
    statusNode.textContent = isEmpty ? '' : '✓ Added to your cart';
    subtotalNode.textContent = money(cart.total_price) + ' ' + currency;
    emptyNode.hidden = !isEmpty;
    footer.hidden = isEmpty;

    cart.items.forEach(function (item) {
      var row = element('article', 'apex-cart-drawer__item');
      var picture = element('a', 'apex-cart-drawer__item-image-link');
      picture.href = item.url || '#';

      if (item.image || (item.featured_image && item.featured_image.url)) {
        var img = element('img', 'apex-cart-drawer__item-image');
        img.src = item.image || item.featured_image.url;
        img.alt = item.product_title || item.title;
        img.loading = 'lazy';
        picture.appendChild(img);
      }

      var details = element('div', 'apex-cart-drawer__item-details');
      var title = element('a', 'apex-cart-drawer__item-title');
      var shortTitles = window.apexCartDisplayTitles || {};
      title.href = item.url || '#';
      title.textContent = shortTitles[item.product_id] || item.product_title || item.title;
      details.appendChild(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        details.appendChild(element('p', 'apex-cart-drawer__item-variant', item.variant_title));
      }
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        details.appendChild(element('p', 'apex-cart-drawer__item-variant', item.selling_plan_allocation.selling_plan.name));
      }

      details.appendChild(element('p', 'apex-cart-drawer__item-price', money(item.final_line_price)));
      if (item.quantity > 1) {
        var unitCents = item.final_line_price / item.quantity;
        var unitText = (Number.isInteger(unitCents) ? '' : 'Avg. ') + money(unitCents) + ' each';
        details.appendChild(element('p', 'apex-cart-drawer__unit-price', unitText));
      }

      var actions = element('div', 'apex-cart-drawer__item-actions');
      var qty = element('div', 'apex-cart-drawer__qty');
      var minus = element('button', '', '−');
      minus.type = 'button';
      minus.dataset.apexQtyChange = '-1';
      minus.dataset.key = item.key;
      minus.setAttribute('aria-label', 'Decrease quantity of ' + item.product_title);
      minus.disabled = item.quantity <= 1;

      var number = element('span', '', String(item.quantity));
      number.setAttribute('aria-label', 'Quantity ' + item.quantity);

      var plus = element('button', '', '+');
      plus.type = 'button';
      plus.dataset.apexQtyChange = '1';
      plus.dataset.key = item.key;
      plus.setAttribute('aria-label', 'Increase quantity of ' + item.product_title);
      qty.append(minus, number, plus);

      var remove = element('button', 'apex-cart-drawer__remove');
      remove.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 10v7"/><path d="M14 10v7"/></svg>';
      remove.type = 'button';
      remove.dataset.apexRemove = '';
      remove.dataset.key = item.key;
      remove.setAttribute('aria-label', 'Remove ' + item.product_title);
      actions.append(qty, remove);
      details.appendChild(actions);
      row.append(picture, details);
      itemsNode.appendChild(row);
    });

    var bubble = document.querySelector('.site-header__cart-count');
    if (bubble) {
      bubble.classList.toggle('hide', cart.item_count === 0);
      var count = bubble.querySelector('span');
      if (count) count.textContent = cart.item_count;
    }
  }

  function loadCartDisplayTitles() {
    return fetch(base + 'cart?section_id=apex-cart-titles', {
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart title section unavailable.');
      return response.text();
    }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var dataNode = doc.querySelector('[data-apex-cart-titles-json]');
      if (!dataNode) throw new Error('Cart title data not found.');
      var titles = JSON.parse(dataNode.textContent);
      if (!titles || typeof titles !== 'object' || Array.isArray(titles)) {
        throw new Error('Invalid cart title data.');
      }
      window.apexCartDisplayTitles = titles;
    });
  }

  function refresh() {
    return request(base + 'cart.js').then(function (cart) {
      return loadCartDisplayTitles().catch(function (error) {
        console.warn('APEX Cart Drawer: short titles unavailable.', error);
      }).then(function () {
        render(cart);
        return cart;
      });
    });
  }

  function open() {
    if (closeTimer !== null) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
    root.classList.remove('apex-cart-drawer--closing');
    if (root.hidden) {
      lastFocus = document.activeElement;
      lastOverflow = document.body.style.overflow;
    }
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    statusNode.hidden = false;
    statusNode.textContent = '✓ Added to your cart';
    clearInventoryWarning();
    messageNode.textContent = 'Loading your cart…';
    panel.focus();
    return refresh().then(function () {
      messageNode.textContent = '';
    }).catch(function () {
      messageNode.textContent = 'Unable to load cart. Please use View Cart.';
    });
  }

  function close() {
    if (root.hidden || closeTimer !== null) return;
    var restoreFocus = lastFocus;
    var restoreOverflow = lastOverflow;

    function finishClose() {
      root.hidden = true;
      root.classList.remove('apex-cart-drawer--closing');
      document.body.style.overflow = restoreOverflow;
      clearInventoryWarning();
      messageNode.textContent = '';
      closeTimer = null;
      if (restoreFocus && typeof restoreFocus.focus === 'function') {
        restoreFocus.focus({ preventScroll: true });
      }
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finishClose();
      return;
    }
    root.classList.add('apex-cart-drawer--closing');
    closeTimer = setTimeout(finishClose, 500);
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-apex-drawer-close]')) {
      close();
      return;
    }
    var button = event.target.closest('[data-apex-qty-change],[data-apex-remove]');
    if (!button || busy) return;
    var row = button.closest('.apex-cart-drawer__item');
    if (!row) return;
    var oldQty = Number(row.querySelector('.apex-cart-drawer__qty span').textContent);
    var removing = button.hasAttribute('data-apex-remove');
    var nextQty = removing ? 0 : oldQty + Number(button.dataset.apexQtyChange);
    if (nextQty < 1 && !removing) return;

    busy = true;
    root.classList.add('apex-cart-drawer--busy');
    clearInventoryWarning();
    messageNode.textContent = 'Updating cart…';

    request(base + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: button.dataset.key, quantity: nextQty })
    }).then(function (cart) {
      render(cart);
      messageNode.textContent = '';
    }).catch(function (error) {
      return refresh().then(function (cart) {
        if (error.status === 422 && nextQty > oldQty) {
          var item = cart.items.find(function (candidate) {
            return candidate.key === button.dataset.key;
          });
          if (item && item.quantity > 0) {
            showInventoryWarning(item.key, item.quantity);
            return;
          }
        }
        messageNode.textContent = error.message;
      }).catch(function () {
        messageNode.textContent = 'Unable to update cart. Please try again.';
      });
    }).finally(function () {
      busy = false;
      root.classList.remove('apex-cart-drawer--busy');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      panel.querySelectorAll(focusSelector),
      function (node) { return node.getClientRects().length > 0; }
    );
    if (!focusable.length) {
      event.preventDefault();
      panel.focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  window.apexCartDrawer = { open: open, close: close, refresh: refresh };
})();
